export default "__VITE_ASSET__CKv1If34__"